<template>
  <el-dialog title="Création d'un appel" :visible.sync="visible" :close-on-click-modal="false" width="30%">
    <el-form ref="form" label-position="top" label-width="150px" :model="form" :rules="fields.validation">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="call.ended_at" label="Date et heure de l'appel">
            <el-date-picker disabled="disabled" v-model="form.call.ended_at" type="datetime"
                            placeholder="Selectionnez une date et une heure"
                            class="form-control" format="dd/MM/yyyy à HH:mm">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="common.customer_id" label="Client">
            <el-select disabled="disabled" v-model="form.common.customer_id" filterable remote :remote-method="searchCustomer"
                       class="form-control" placeholder="Select">
              <customer v-for="customer in fields.customers" :key="customer.id" :item="customer"
                        present="option"></customer>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" id="reminder-block" :class="['row-block', fields.reminder ? 'active' : '']">
        <el-col :span="24">
          <el-checkbox v-model="fields.reminder" style="margin-bottom: 15px;">Rappel programmé</el-checkbox>

          <vue-slide-up-down :active="fields.reminder" :duration="200">
            <el-row :gutter="20">
              <el-col :span="16">
                <el-form-item v-if="!form.reminder.meeting" prop="date" label="Date du rappel">
                  <el-date-picker v-model="form.reminder.date"
                                  v-on:click.native="form.reminder.date = null; form.reminder.date = moment()"
                                  type="date"
                                  placeholder="Selectionnez une date" class="form-control"
                                  :picker-options="fields.date" format="dd/MM/yyyy">
                  </el-date-picker>
                </el-form-item>
                <el-form-item v-if="form.reminder.meeting" prop="date" label="Date et heure du rendez-vous">
                  <el-date-picker v-model="form.reminder.date" type="datetime"
                                  placeholder="Selectionnez une date et une heure" class="form-control"
                                  :picker-options="fields.date" format="dd/MM/yyyy à HH:mm">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-checkbox v-model="form.reminder.meeting" style="margin-top: 30px;">Rendez-vous</el-checkbox>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="category_id" label="Type">
                  <el-select v-model="form.reminder.category_id" class="form-control" placeholder="Select">
                    <el-option
                      v-for="category in categories"
                      :key="category.id"
                      :label="category.name"
                      :value="category.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="note" label="Note">
                  <el-input type="textarea" autosize placeholder="Saisissez une note de rappel"
                            v-model="form.reminder.description"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </vue-slide-up-down>
        </el-col>
      </el-row>
      <el-row :gutter="20" id="success-block" :class="['row-block', form.call.successful ? 'active' : '']">
        <el-col :span="24">
          <el-checkbox v-model="form.call.successful" style="margin-bottom: 15px;">Appel abouti</el-checkbox>

          <vue-slide-up-down :active="form.call.successful" :duration="200">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Sujet de l'appel">
                  <el-select v-model="form.call.tags.subject" class="form-control" placeholder="Select">
                    <el-option label="Proactif" :value="3"></el-option>
                    <el-option label="Renouvellement" :value="4"></el-option>
                    <el-option label="Pas intéressé" :value="13"></el-option>
                    <el-option label="Décision" :value="5"></el-option>
                    <el-option label="Proposition" :value="6"></el-option>
                    <el-option label="Relance Paiement" :value="7"></el-option>
                    <el-option label="Confortation" :value="8"></el-option>
                    <el-option label="BDC" :value="9"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Interlocuteur">
                  <el-radio-group v-model="form.call.tags.interlocutor">
                    <el-radio :label="10">Secrétaire</el-radio><br />
                    <el-radio :label="11">Responsable</el-radio><br />
                    <el-radio :label="12">Comptable</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="Propale envoyée">
                  <el-select v-model="form.proposition.type_id" class="form-control" placeholder="Aucune propale">
                    <el-option label="Leads" :value="1"></el-option>
                    <el-option label="Rendez-vous" :value="2"></el-option>
                    <el-option label="Publicités" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12" v-if="form.proposition.type_id === 3">
                <el-form-item label="Montant de la propale">
                  <el-input v-model="form.proposition.amount">
                    <template slot="append">€</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </vue-slide-up-down>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="pull-right"><el-button @click="form.comment.description = bold('call_comment')" size="small"><i class="zmdi zmdi-format-bold"></i></el-button></div>
          <el-form-item prop="comment" label="Commentaire">
            <el-input id="call_comment" type="textarea" autosize placeholder="Saisissez un commentaire lié à l'appel"
                      v-model="form.comment.description"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-on:click="visible = false">Annuler</el-button>
      <el-button type="success" v-on:click="submit()">Créer un appel</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import Customer from '../Entities/Customer.vue'
  import VueSlideUpDown from 'vue-slide-up-down'
  import moment from 'moment'
  import _ from 'lodash'

  let $ = window.$

  export default {
    components: {
      Customer,
      VueSlideUpDown
    },
    name: 'call-modal',
    data () {
      return {
        visible: false,
        advanced: false,
        content: {
          title: '',
          button: '',
          button_type: ''
        },
        fields: {
          validation: {},
          reminder: false,
          date: {
            shortcuts: [{
              text: '+ 1 heure',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 2 heures',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 2 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 1 jour',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 2 jours',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 2 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 1 semaine',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 2 semaines',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 2 * 7 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 3 semaines',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 3 * 7 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 1 mois',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 2 mois',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 2 * 30 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }]
          },
          customers: []
        },
        form: {
          common: {
            user_id: this.$store.getters['users/current'].id,
            customer_id: null,
            quote_id: null
          },
          call: {
            type_id: null,
            ended_at: null,
            successful: false,
            tags: {
              subject: 3,
              interlocutor: 10,
            }
          },
          proposition: {
            type_id: null,
            amount: 0
          },
          reminder: {
            id: null,
            category_id: null,
            meeting: false,
            date: null,
            description: ''
          },
          comment: {
            badge: this.keystone.config.components.modals.comment['default_badge'],
            description: ''
          }
        }
      }
    },
    watch: {
      visible (visible) {
        if (!visible) {
          this.reset()
        }
      },
      fields: {
        handler: function (after, before) {
          if (after.reminder) {
            setTimeout(() => {
              $('#reminder-block > div > div').css('height', '')
            }, 200)
          }
        },
        deep: true
      },
      form: {
        handler: function (after, before) {
          if (after.call.successful) {
            setTimeout(() => {
              $('#success-block > div > div').css('height', '')
            }, 200)
          }
        },
        deep: true
      }
    },
    mounted () {
      let self = this
      this.$model.call.on('create', ({item}) => {
        self.reset()

        if (item.customer) {
          self.form.call.type_id = 2
          self.fields.customers = [item.customer]
          self.form.common.customer_id = item.customer.id
        }
        if (_.get(item, 'quote_id', null)) {
          // TODO
        }

        if (item.reminder) {
          self.fields.reminder = true
          self.form.reminder.id = item.reminder.id
          self.form.reminder.category_id = item.reminder.category_id
          self.form.reminder.meeting = !!item.reminder.meeting
          self.form.reminder.date = item.reminder.date.date
          self.form.reminder.description = item.reminder.description

          switch(item.reminder.category_id) {
            case 1: self.form.call.tags.subject = 4; break;
            case 2: self.form.call.tags.subject = 5; break;
            case 3: self.form.call.tags.subject = 6; break;
            case 4: self.form.call.tags.subject = 7; break;
            case 5: self.form.call.tags.subject = 8; break;
            case 6: self.form.call.tags.subject = 9; break;
          }
        } else {
          self.fields.reminder = false
        }

        self.form.call.ended_at = moment()
        self.visible = true
      })
    },
    methods: {
      bold (id) {
        let el = $('#' + id).find('textarea', 0)
        let selection = {
          start: $(el).prop('selectionStart'),
          end : $(el).prop('selectionEnd') + 1
        }

        let val = $(el).val()
        let selectionStart = {
          before: val.substring(0,  selection.start),
          after:  val.substring(selection.start, val.length)
        }
        val = selectionStart.before + '*' + selectionStart.after

        let selectionEnd = {
          before: val.substring(0,  selection.end),
          after:  val.substring(selection.end, val.length)
        }
        val = selectionEnd.before + '*' + selectionEnd.after
        return val
      },
      searchCustomer (query) {
        let self = this

        if (query.length > 2) {
          this.$nexus.get('crm2', 'customers/search', {params: {query}}).then(response => {
            self.fields.customers = response.data.data
          })
        }
      },
      reset () {
        this.form = this.$options.data.apply(this).form
        // this.$refs['form'].resetFields()
      },
      getTags () {
        let tags = []
        tags.push(this.form.call.tags.subject)
        tags.push(this.form.call.tags.interlocutor)
        return tags
      },
      submit () {
        let self = this

        this.$refs['form'].validate((valid) => {
          if (valid) {
            let p = []

            p.push(self.$model.call.api().create({
              user_id: self.form.common.user_id,
              customer_id: self.form.common.customer_id,
              type_id: self.form.call.type_id,
              successful: self.form.call.successful,
              ended_at: self.form.call.ended_at,
              tags: self.form.call.successful ? self.getTags() : []
            }))

            if (self.form.call.successful && self.form.proposition.type_id) {
              p.push(self.$model.proposal.api().create({
                user_id: self.form.common.user_id,
                type_id: self.form.proposition.type_id,
                customer_id: self.form.common.customer_id,
                amount: self.form.proposition.amount === 0 ? null : self.form.proposition.amount,
                accepted_at: null
              }))
            }

            if (self.form.comment.description.length > 0) {
              p.push(self.$model.comment.api().create({
                user_id: self.form.common.user_id,
                customer_id: self.form.common.customer_id,
                badge: self.form.comment.badge,
                description: self.form.comment.description
              }))
            }

            if (self.fields.reminder) {
              let reminder = {
                user_id: self.form.common.user_id,
                category_id: self.form.reminder.category_id,
                customer_id: self.form.common.customer_id,
                date: self.form.reminder.date,
                description: self.form.reminder.description,
                meeting: self.form.reminder.meeting
              }

              if (self.form.reminder.id) {
                reminder.id = self.form.reminder.id
                p.push(self.$model.reminder.api().update(reminder.id, reminder))
              } else {
                p.push(self.$model.reminder.api().create(reminder))
              }
            } else if (self.form.reminder.id) {
              p.push(self.$model.reminder.api().delete(self.form.reminder.id))
            }

            Promise.all(p).then(function (values) {
              self.visible = false
            })
          } else {
            self.$message.error('Impossible de valider le formulaire. Merci de vérifier les valeurs saisies')
          }
        })
      }
    },
    computed: {
      user () {
        return this.$store.getters['users/current']
      },
      categories () {
        return this.$store.getters['reminder_categories/all']
      },
      tags () {
        let self = this
        return this.$store.getters['tags/all'].filter(tag => tag.call_type_id === self.form.call.type_id)
      }
    }
  }
</script>

<style scoped>
  .row-block {
    border-left: 2px solid #cccccc;
    margin-left: 0 !important;
    padding-left: 10px;
    margin-bottom: 10px;
    padding-top: 10px;
    transition: all 0.2s;
  }

  .row-block.active {
    margin-left: 5px !important;
    padding-left: 5px;
    border-left: 2px solid rgb(100, 176, 242);
    background-color: rgba(100, 176, 242, 0.1);
  }
</style>



// WEBPACK FOOTER //
// CallModal.vue?54f020c7